import React from 'react';
import { Spinner } from 'reactstrap';

//import './Spinner.css';

const spinner = () => (
    <div>
        <Spinner type="grow" color="primary" />
        <Spinner type="grow" color="secondary" />
        <Spinner type="grow" color="success" />
    </div>
);

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js